/**
 * Utility function to generate consistent badge color classes based on state and fill type
 * Used across LogsView, AzureLogsView, and other components that need state badges
 */
export const getStateColorClass = (
  stateColor?: string,
  filled: boolean = false,
): string => {
  const baseClasses = "text-xs py-0 px-1.5";

  if (!filled) {
    // Outlined variant - light background with colored text
    switch (stateColor) {
      case "primary":
        return `${baseClasses} bg-white text-blue-600 border border-blue-400`;
      case "secondary":
        return `${baseClasses} bg-white text-blue-600 border border-blue-400`;
      case "success":
        return `${baseClasses} bg-white text-emerald-600 border border-emerald-400`;
      case "error":
        return `${baseClasses} bg-white text-red-600 border border-red-400`;
      case "info":
        return `${baseClasses} bg-white text-sky-600 border border-sky-400`;
      case "warning":
        return `${baseClasses} bg-white text-orange-500 border border-orange-300`;
      default:
        return `${baseClasses} bg-white text-gray-600 border border-gray-400`;
    }
  } else {
    // Filled variant - colored background with white/contrasting text
    switch (stateColor) {
      case "primary":
        return `${baseClasses} bg-blue-600 text-white`;
      case "secondary":
        return `${baseClasses} bg-gray-600 text-white`;
      case "success":
        return `${baseClasses} bg-green-600 text-white`;
      case "error":
        return `${baseClasses} bg-orange-700 text-white`;
      case "info":
        return `${baseClasses} bg-blue-600 text-white`;
      case "warning":
        return `${baseClasses} bg-orange-600 text-white`;
      default:
        return `${baseClasses} bg-gray-600 text-white`;
    }
  }
};
